export default {
  ADVANCED_FILTER: 'Advanced Filter',
  ADVANCED_FILTERS: 'Advanced Filters',
  ALL_CONSTITUENTS: 'All Constituents',
  BACK_TO_FILTERS: 'Back to all filters',
  BULK_ACTION_STATUS_IN_PROGRESS:
    'Working on your request, this may take a minute. You have {count} {count, plural, =1 {job} other {jobs}} in progress.',
  COLUMNS: 'Columns',
  CONNECTED_TO: 'Connected To',
  CONSTITUENT: 'Constituent',
  CONSTITUENTS: 'Constituents',
  CONSTITUENTS_ACTIVITY_TAB: 'Activity',
  CONSTITUENTS_ADD_CONSTITUENT_LABEL: 'Add constituent as',
  CONSTITUENTS_EXPORT_MAILCHIMP_DYNAMIC_FIELDS:
    'Please note that you need a "Standard" or "Premium" tier Mailchimp account in order to export the Dynamic Fields.',
  CONSTITUENTS_LIST: 'Constituents List',
  CONSTITUENTS_NEW_CONSTITUENT_INDIVIDUAL_LABEL: 'Individual',
  CONSTITUENTS_NEW_CONSTITUENT_ORG_LABEL: 'Organization',
  CONSTITUENTS_NOTE_PLACEHOLDER_1: 'Goal with this constituent',
  CONSTITUENTS_NOTE_PLACEHOLDER_2: 'Interesting tidbit',
  CONSTITUENTS_NOTE_PLACEHOLDER_3: 'Things to avoid',
  CONSTITUENTS_RECENTLY_VIEWED_EMPTY: 'No Recently Viewed',
  CONSTITUENTS_TABLE_HEADER: 'Constituents ({count})',
  CONSTITUENT_ADD_LABEL: 'Add Label',
  CONSTITUENT_ADVOCATE_LABEL: 'Advocate',
  CONSTITUENT_ASSIGNED_TO: 'Assigned to',
  CONSTITUENT_ASSIGNED_TO_ALL: 'Show all',
  CONSTITUENT_ASSIGNED_TO_ME: 'Assigned to me',
  CONSTITUENT_ASSIGNEE: 'Assignee',
  CONSTITUENT_ASSIGNEE_ASSIGNED: 'All assigned',
  CONSTITUENT_ASSIGNEE_UNASSIGNED: 'All unassigned',
  CONSTITUENT_BIO_LABEL: 'Bio',
  CONSTITUENT_BOARD_MEMBER_LABEL: 'Board Member',
  CONSTITUENT_BULK_EDIT_UPDATE_ERROR: 'Something went wrong, please try again.',
  CONSTITUENT_BULK_EDIT_UPDATE_IN_PROGRESS:
    'Working on your request, this may take a minute.',
  CONSTITUENT_BULK_EDIT_UPDATE_SUCCESS: 'Your edits have been saved',
  CONSTITUENT_CALL: 'Call',
  CONSTITUENT_CATEGORIES_REQUIRED_ERROR: 'Select at least 1 category',
  CONSTITUENT_CATEGORY: 'Category',
  CONSTITUENT_CONFIRM_REMOVE_FILTER:
    'Are you sure you want to delete the "{filterName}" saved filter?',
  CONSTITUENT_CONSTANT_CONTACT_TAG_HELPER:
    'This will be the tag assigned within Constant Contact',
  CONSTITUENT_CONSTANT_CONTACT_TAG_NAME: 'Constant Contact Tag Name',
  CONSTITUENT_CONSTITUENT_CATEGORY: 'Constituent Category',
  CONSTITUENT_CONTRIBUTED_MONETARY: 'Contribution Amount ($)',
  CONSTITUENT_CONTRIBUTED_TIME: 'Contribution Amount (Hours)',
  CONSTITUENT_CONVERT: 'Convert',
  CONSTITUENT_CONVERTING: 'Converting constituent type',
  CONSTITUENT_CONVERT_CONFIRM: 'Are you sure you want to continue?',
  CONSTITUENT_CONVERT_MESSAGE:
    'This constituent will be converted from an {from} to an {to}.',
  CONSTITUENT_CONVERT_TO_INDIVIDUAL: 'Convert to Individual',
  CONSTITUENT_CONVERT_TO_ORGANIZATION: 'Convert to Organization',
  CONSTITUENT_COPY_ADDRESS: 'Copy Address',
  CONSTITUENT_COPY_NUMBER: 'Copy Number',
  CONSTITUENT_CORPORATION_LABEL: 'Corporation',
  CONSTITUENT_CREATE_CONNECTION_ERROR_MESSAGE:
    'There was a problem creating {name}',
  CONSTITUENT_CREATE_UPDATING_ERROR_MESSAGE:
    'There was a problem updating {name}',
  CONSTITUENT_DONOR_LABEL: 'Donor',
  CONSTITUENT_EXISTS_IN_SYSTEM:
    'Email address must be unique. This address is currently associated with <link-to-constituent>{displayName}</link-to-constituent>.',
  CONSTITUENT_EXPORTING:
    'Exporting {total, plural, =1 {1 Constituent} other {# Constituents}}',
  CONSTITUENT_EXPORTING_FIELDS:
    'First Name, Last Name, Email Address, Phone Number, and Mailing Address',
  CONSTITUENT_EXPORTING_FIELDS_EXPORTED: 'Fields being exported:',
  CONSTITUENT_EXPORTING_TO_DESTINATION:
    'You are currently exporting {total, plural, =1 {1 Constituent} other {# Constituents}} to {destination}',
  CONSTITUENT_EXPORT_BASIC_PROFILE: 'Basic Profile',
  CONSTITUENT_EXPORT_BASIC_PROFILE_DESCRIPTION:
    'These are the fields that make up your constituent’s profile.',
  CONSTITUENT_EXPORT_BASIC_PROFILE_TOGGLE: 'Toggle Basic Profile Form Fields',
  CONSTITUENT_EXPORT_CONSTANT_CONTACT: 'Export to Constant Contact',
  CONSTITUENT_EXPORT_CUSTOM_FIELDS: 'Custom Fields',
  CONSTITUENT_EXPORT_CUSTOM_FIELDS_DESCRIPTION:
    'These will include all custom fields that have been added to a profile to suit your organization’s needs.',
  CONSTITUENT_EXPORT_DOWNLOAD_CSV: 'Download as .csv',
  CONSTITUENT_EXPORT_DYNAMIC_FIELDS: 'Export Dynamic Fields',
  CONSTITUENT_EXPORT_HOUSEHOLD_INFORMATION: 'Household Information',
  CONSTITUENT_EXPORT_HOUSEHOLD_INFORMATION_DESCRIPTION:
    'These are fields that have been customized to a profile for better personalization.',
  CONSTITUENT_EXPORT_HOUSEHOLD_INFORMATION_TOGGLE:
    'Toggle Household Information Form Fields',
  CONSTITUENT_EXPORT_HOW: 'How would you like to export your data?',
  CONSTITUENT_EXPORT_LIST: 'Export Constituent List',
  CONSTITUENT_EXPORT_MAILCHIMP: 'Export to Mailchimp',
  CONSTITUENT_EXPORT_MAILCHIMP_FIELDS: 'Fields being exported include:',
  CONSTITUENT_EXPORT_PREFERRED_HOUSEHOLD_GREETING:
    'Preferred Household Greeting',
  CONSTITUENT_EXPORT_SPOUSE_PARTNER_NAME: 'Spouse/Partner Name',
  CONSTITUENT_EXPORT_SPOUSE_PARTNER_EMAIL: 'Spouse/Partner Email',
  CONSTITUENT_EXPORT_SUCCESS_OUTBOUND_INTEGRATION:
    'Your export is being sent to {integration}.',
  CONSTITUENT_EXPORT_SUCCESS_OUTBOUND_MESSAGE:
    'After your list has been sent, a confirmation will be emailed to {email}.',
  CONSTITUENT_FIELDS_INCLUDE: 'Fields to Include',
  CONSTITUENT_FILTER_CONFIRMATION:
    'Your current filters have been saved as “{filterName}”',
  CONSTITUENT_FILTER_DUPLICATE_ERROR: 'This filter name is already in use.',
  CONSTITUENT_FILTER_NAME: 'Filter Name',
  CONSTITUENT_FILTER_NAME_REQUIRED: 'Filter Name Required',
  CONSTITUENT_FILTER_SAVE_FILTER: 'Create Saved Filter',
  CONSTITUENT_FILTER_SAVE_MODAL:
    'This will save your current filter settings for future use.',
  CONSTITUENT_FILTER_SAVE_PROMPT: 'Would you like to save this filter set?',
  CONSTITUENT_FOUNDATION_LABEL: 'Foundation',
  CONSTITUENT_GOVERNMENT_LABEL: 'Government',
  CONSTITUENT_INCLUDE_ALL_CUSTOM_FIELDS: 'Include All Custom Fields',
  CONSTITUENT_INFORMATION: 'Constituent Information',
  CONSTITUENT_LABELS: 'Labels',
  CONSTITUENT_LAST_CONTRIBUTION: 'Last Contribution',
  CONSTITUENT_LIFETIME_GIVING: 'Lifetime Giving',
  CONSTITUENT_LIST_ADD_LABELS: 'Add Labels',
  CONSTITUENT_LIST_ADD_LABEL_HEADER:
    'Add labels to {count} selected {count, plural, =1 {constituent} other {constituents}}',
  CONSTITUENT_LIST_CLEAR_SELECTED: 'Clear Selected',
  CONSTITUENT_LIST_MOVE_BOARD_HEADER:
    'Move {count} selected {count, plural, =1 {constituent} other {constituents}}',
  CONSTITUENT_LIST_SELECTED:
    '{count} selected {allSelected, select, true {in filter group} other {}}',
  CONSTITUENT_LIST_SELECT_ALL: 'Select all {count} in filtered group',
  CONSTITUENT_LIST_SET_BOARD: 'Set Board',
  CONSTITUENT_MAILCHIMP_AUDIENCE: 'Mailchimp Audience',
  CONSTITUENT_MAILCHIMP_TAG_HELPER:
    'This will be the tag assigned within Mailchimp',
  CONSTITUENT_MAILCHIMP_TAG_NAME: 'Mailchimp Tag Name',
  CONSTITUENT_MAJOR_DONOR_LABEL: 'Major Donor',
  CONSTITUENT_MEMBER_LABEL: 'Member',
  CONSTITUENT_NAME_LABEL: 'Constituent Name',
  CONSTITUENT_PARTNER_LABEL: 'Partner',
  CONSTITUENT_RECIPIENT_LABEL: 'Client',
  CONSTITUENT_RECURRING_LABEL: 'Recurring',
  CONSTITUENT_REMOVE_CONFIRMATION:
    "Are you sure you want to remove this constituent's card from the board?",
  CONSTITUENT_REMOVE_CONNECTION_ERROR_MESSAGE:
    'There was a problem removing {name}',
  CONSTITUENT_SAVED_FILTERS: 'Saved Filters',
  CONSTITUENT_SEARCH: 'Search Constituents',
  CONSTITUENT_SEARCH_BY: 'Search by Name, Email, or Phone',
  CONSTITUENT_SEND_EMAIL: 'Send Email',
  CONSTITUENT_SORT_NEWEST: 'Newest Interaction',
  CONSTITUENT_SORT_OLDEST: 'Oldest Interaction',
  CONSTITUENT_TOTAL_AMT_CONTRIBUTED: 'Total Amount',
  CONSTITUENT_TOTAL_MONETARY_CONTRIBUTED: 'Total Monetary',
  CONSTITUENT_TOTAL_TIME_CONTRIBUTED: 'Total Time',
  CONSTITUENT_TYPE: 'Constituent Type',
  CONSTITUENT_UNASSIGNED: 'Unassigned',
  CONSTITUENT_UNCATEGORIZED: 'Uncategorized',
  CONSTITUENT_VIP_LABEL: 'VIP',
  CONSTITUENT_VOLUNTEER_LABEL: 'Volunteer',
  CONTRIBUTION_INFORMATION: 'Contribution Information',
  CREATE_CONSTITUENT_ERROR_MESSAGE: 'There was a problem creating {name}',
  DECEASED_STATUS: 'Deceased Status',
  DELETE_CONSTITUENT: 'Delete Constituent',
  DELETE_CONSTITUENT_CONFIRMATION_MESSAGE:
    'Are you sure you want to delete this constituent? All associated data will be removed. This action is permanent and cannot be undone.',
  DELETE_CONSTITUENT_ERROR_MESSAGE: 'There was a problem deleting {name}',
  DELETE_CONSTITUENT_SUCCESS_MESSAGE: 'Constituent successfully deleted',
  DISPLAY_COLUMNS: 'Display Columns',
  EMAIL_ADDRESSES_LABEL: 'Email Address',
  EXPORT_ERROR: 'Something went wrong.',
  EXPORT_ERROR_MESSAGE: 'Try exporting your list again.',
  EXPORT_FILE_GENERATED: 'Your file is being generated.',
  EXPORT_SUCCESS_DOWNLOADS_LINK: 'Or, visit your downloads page.',
  EXPORT_SUCCESS_MESSAGE:
    'A link to download your exported file will be emailed to {email} shortly. ',
  EXTERNAL_ID: 'External ID',
  FETCH_CONSTITUENT_ERROR_MESSAGE: 'There was a problem fetching a constituent',
  FILTERS: 'Filters',
  HIDE_CUSTOM_FIELDS: 'Hide Custom Fields',
  MAILING_ADDRESSES_LABEL: 'Mailing Address(es)',
  PHONE_NUMBERS_LABEL: 'Phone Number',
  SHOW_CUSTOM_FIELDS: 'Show Custom Fields',
  SOCIAL_MEDIA: 'Social Media',
  UPDATE_CONSTITUENT_ERROR_MESSAGE: 'There was a problem updating {name}',
  CONSTITUENT_SEARCH_AGGREGATE_TOOLTIP:
    "<p>Combining Contribution filters applies all criteria as a group; otherwise, criteria are applied independently.</p><p>E.g., Combining Contribution Type and Date filters returns constituents who made contributions of that type on that date. Otherwise, results will show constituents who made contributions on that date and constituents who made contributions of that type.</p><p>When a time period is specified for Contributions, the 'Single Amount' value becomes a cumulative total of all contributions made during that period</p>",
  CONSTITUENT_SEARCH_AGGREGATE_LABEL: 'Combine contribution filters',
};
